import log from 'salvo-lite/log'

class CartStorage {
    constructor (theme, elem) {
        this._name = this.constructor.name
        this._elem = elem
    }

    onInit () {
        log.debug(this._name, 'Initiated', this)
        this._elem.addEventListener('click', e => {
            e.preventDefault()
            localStorage.setItem('go_to_cart', true)
            window.location.href = this._elem.href
        })
    }
}

export default CartStorage



// WEBPACK FOOTER //
// ./src/scripts/components/CartStorage.js